import { CdkAccordionModule } from '@angular/cdk/accordion';
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatRippleModule } from '@angular/material/core';
import { MatIconModule } from '@angular/material/icon';
import { MatListModule } from '@angular/material/list';
import { MatTooltipModule } from '@angular/material/tooltip';
import { RouterModule } from '@angular/router';
import { ComponentSharedModule } from '@components/component.shared.module';
import { UiFolderPickerModule } from '@components/ui-folder-picker/ui-folder-picker.module';
import { UiSidebarAccordionComponent } from '@components/ui-sidebar/ui-sidebar-accordion.component';
import { UiSidebarNavigationComponent } from '@components/ui-sidebar/ui-sidebar-navigation.component';
import { TranslateModule } from '@ngx-translate/core';
import { UiNgLetModule } from '@uipath/angular/directives/ui-ng-let';

@NgModule({
    imports: [
        RouterModule,
        CommonModule,
        ComponentSharedModule,
        TranslateModule,
        MatIconModule,
        UiNgLetModule,
        MatTooltipModule,
        UiFolderPickerModule,
        CdkAccordionModule,
        MatButtonModule,
        MatListModule,
        MatRippleModule,
    ],
    declarations: [
        UiSidebarAccordionComponent,
        UiSidebarNavigationComponent,
    ],
    exports: [
        UiSidebarNavigationComponent,
    ],
})
export class UiSidebarNavigationModule { }
